// Single source of truth for domain, publisher, and publication metadata.
// To re-home the site, change SITE_URL and redeploy. Everything downstream
// (canonicals, JSON-LD, sitemap) reads from here.
export const SITE_URL = "https://spainsmileguide.com";
export const SITE_NAME = "Spain Smile Guide";
export const SITE_TAGLINE = "An editorial resource on choosing a smile-makeover clinic in Spain.";
export const PUBLISHER = {
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/logo.svg`,
    },
};
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;
// The publication is affiliated with ACE DNTL STUDIO. This fact is
// surfaced in the About page, in per-article disclosures, and in the
// AboutPage JSON-LD. Do not remove.
export const AFFILIATION = {
    parentOrganization: {
        "@type": "Organization",
        name: "ACE DNTL STUDIO",
        url: "https://acedntl.com",
    },
    disclosure: "Spain Smile Guide is an editorial publication affiliated with the ACE DNTL STUDIO group. It applies a single published rubric to every clinic it evaluates, including ACE DNTL. See our methodology.",
};
export const DEFAULT_AUTHOR = {
    "@type": "Organization",
    name: "Spain Smile Guide Editorial",
    url: `${SITE_URL}/about`,
};
